import { render, staticRenderFns } from "./ContactViewQuestion.vue?vue&type=template&id=01535977&"
import script from "./ContactViewQuestion.vue?vue&type=script&lang=js&"
export * from "./ContactViewQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports